<script>
import { mapGetters } from 'vuex'
import UserEditForm from '../../components/UserEditForm.vue'

export default {
    name: 'AccountProfile',
    components: { UserEditForm },
    computed: {
        ...mapGetters(['userResource'])
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Perfil</h4>
            <p class="text-muted mb-0">Administra tu información personal y detalles de corredor.</p>
        </div>
        <b-card>
            <user-edit-form :user-resource="userResource" submit-text="Guardar Perfil" success-message="¡Perfil Guardado!" />
        </b-card>
    </div>
</template>
